if (!customElements.get('slider-default')) {
  class SliderDefault extends HTMLElement {
    constructor() {
      super();

      this.sliderOptions = {
        slidesPerView: 'auto',
      };

      this.initSlider();
    }

    initSlider() {
      const nextEl = this.querySelector('.js-next');
      const prevEl = this.querySelector('.js-prev');

      this.sliderOptions.navigation = {
        nextEl: nextEl,
        prevEl: prevEl,
      };

      this.slider = new Swiper(
        this.querySelector('.js-slider'),
        this.sliderOptions,
      );
    }
  }

  customElements.define('slider-default', SliderDefault);
}
